import { SURF_SPLIT_SYSTEM } from "./outlinePrompt.js";
export const SURF_SLIDE_EXTRACT_SYSTEM = [
    SURF_SPLIT_SYSTEM,
    "",
    "Modalità estrazione singola slide:",
    "- Produci UNA sola sezione slide (non un array).",
    "- Rispondi con JSON fenced: ```json { \"slide\": { ... } } ```",
    "- I testi (title, subtitle, bullets, body, notes) devono essere estratti VERBATIM dal materiale sorgente.",
    "- VIETATO inventare dati, numeri o citazioni non presenti nel sorgente.",
    "- Se l'utente indica un argomento, estrai solo contenuto pertinente a quell'argomento.",
    "- Se l'argomento è assente, estrai il prossimo tema sostanziale NON ancora coperto dalle sezioni esistenti.",
    "- Non duplicare titoli o temi già presenti nell'elenco sezioni esistenti.",
    "- 3–6 bullets sostanziali quando il ruolo è content/section/comparison/data.",
].join("\n");
export function buildSlideExtractUserPrompt(sourceTitle, sourceBody, existingSections, topic) {
    const body = sourceBody.trim().slice(0, 24_000);
    const existing = existingSections
        .map((s, i) => `${i + 1}. ${s.title.trim() || "(senza titolo)"}`)
        .join("\n");
    const lines = [
        sourceTitle ? `Titolo sorgente: ${sourceTitle}` : "Titolo sorgente: (senza titolo)",
        "",
        "Materiale sorgente (Markdown):",
        body,
        "",
        "Sezioni outline già presenti (non duplicare):",
        existing || "(nessuna)",
    ];
    if (topic?.trim()) {
        lines.push("", `Argomento richiesto per la nuova slide: ${topic.trim()}`);
    }
    else {
        lines.push("", "Argomento: (non specificato) — estrai il prossimo tema rilevante non ancora coperto.");
    }
    return lines.join("\n");
}
